<template lang="html">
  <div class="container">

    <div class="row logobox">

      <div class="offset-md-4 col-md-4 text-center">
        <img src="https://tma-bensberg.de/wp-content/uploads/2015/10/tma-logo.png" class="logo" alt="TMA Logo" />
      </div>

    </div>

    <div class="row loginform">

      <div class="offset-md-4 col-md-4 text-center">

        <form @submit="login">

          <div class="form-group text-left">
                  <label for="inputEmail">E-Mail</label>
                  <input class="form-control" id="inputEmail" placeholder="E-Mail Adresse" v-model="email" />
          </div>

          <div class="form-group text-left">
                  <label for="inputPasswort">Passwort</label>
                  <input class="form-control" id="inputPasswort" placeholder="Passwort eingeben" type="password" v-model="password" />
          </div>

          <div class="text-right">
              <button class="btn btn-primary" type="submit">Anmelden</button>
          </div>

        </form>
      </div>

    </div>
    <div v-if="loginFailed" class="row">
      <div class="offset-md-4 col-md-4 text-center">
        <div class="alert alert-danger">
          Leider war die eingegebene Kombination aus Benutzername und Passwort ungültig. Bitte versuchen Sie es erneut.
        </div>
      </div>
    </div>


  </div>
</template>

<script>
import store from '@/state/store'

export default {
  beforeRouteEnter (to, from, next) {
    if(store.state.auth.token){
      next( (from.name == null) ? 'admin' : from )
    } else {
      next()
    }
  },
  data () {
    return {
      email: '',
      password: '',
      loginFailed: null
    }
  },
  methods: {
    async login (event) {
      event.preventDefault();
      try{
        let result = await this.$store.dispatch('auth/LOGIN', {email: this.email, password: this.password})
        if(result) {
          this.$router.push('/admin')
        }
      } catch (e) {
        //Show fail box
        this.loginFailed = true;
      }
    }
  }
}
</script>

<style lang="scss">
.logobox {
  margin-top:100px;
}
.loginform {
  margin-top:30px;
  margin-bottom:30px;
}
.logo {
  width:300px;
}
</style>



// WEBPACK FOOTER //
// src/views/Login.vue